"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const L2Book_1 = require("../L2Book");
const Feedhandler_1 = require("./Feedhandler");
class MangoFeedHandler extends Feedhandler_1.FeedHandler {
    constructor() {
        super('Mango', 'wss://api.mango-bowl.com/v1/ws');
    }
    onOpen(event) {
        const subscribeL2 = {
            op: 'subscribe',
            channel: 'level2',
            markets: [this.getSymbol()]
        };
        this.ws().send(JSON.stringify(subscribeL2));
        const subscribeTrades = {
            op: 'subscribe',
            channel: 'trades',
            markets: [this.getSymbol()]
        };
        this.ws().send(JSON.stringify(subscribeTrades));
    }
    onMessage(event) {
        const msg = JSON.parse(event.data);
        const typ = msg.type;
        if (['l2snapshot', 'l2update'].includes(typ)) {
            this.handleOrderBookEvent(msg);
        }
        if (['trade'].includes(typ)) {
            this.handleTradeEvent(msg);
        }
    }
    handleOrderBookEvent(msg) {
        const translatedEvent = {
            action: msg.typ === 'l2snapshot' ? L2Book_1.OrderBookAction.Partial : L2Book_1.OrderBookAction.Update,
            bids: msg.bids.map((x) => [Number.parseFloat(x[0]), Number.parseFloat(x[1])]),
            asks: msg.asks.map((x) => [Number.parseFloat(x[0]), Number.parseFloat(x[1])])
        };
        this.publishOrderBookEvent(translatedEvent);
    }
    handleTradeEvent(msg) {
        const trade = {
            price: Number.parseFloat(msg.price),
            size: Number.parseFloat(msg.size),
            side: msg.side === 'buy' ? L2Book_1.Side.Buy : L2Book_1.Side.Sell
        };
        this.publishTradeEvent(trade);
    }
}
exports.default = MangoFeedHandler;
